import { isTransportOrder, type Order } from '#domain/Order.ts';
import type { StopDetails } from '#domain/Stop.ts';

export const getSelectedOrderDetails = (orders: Order[], selectedOrderIds: string[], stops: StopDetails[]): Order[] => {
    const stopById = new Map(stops.map(stop => [stop.id, stop]));

    return orders
        .filter(order => selectedOrderIds.includes(order.id))
        .map(order => {
            if (!isTransportOrder(order)) {
                return order;
            }
            const loadingMaterials = stopById.get(order.loadingStop.id)?.materials ?? [];
            const unloadingMaterials = stopById.get(order.unloadingStop.id)?.materials ?? [];

            return {
                ...order,
                materials: loadingMaterials.length ? loadingMaterials : unloadingMaterials,
            };
        });
};
